import { NavLink } from 'react-router-dom';
import { Mail, ListChecks, FileCode2, Send, Zap } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * Secondary navigation inside the admin "Subscribers" area — Subscribers ·
 * Lists · Templates · Broadcasts · Automations. Sits under the top-level
 * AdminSectionTabs.
 */
export function SubscribersSubNav() {
  return (
    <nav
      aria-label="Subscriber sections"
      className="inline-flex items-center rounded-full border border-or-slate-200 bg-white p-1"
    >
      <Tab to="/admin/subscribers" icon={<Mail className="h-3.5 w-3.5" aria-hidden />} end>
        Subscribers
      </Tab>
      <Tab to="/admin/subscribers/lists" icon={<ListChecks className="h-3.5 w-3.5" aria-hidden />}>
        Lists
      </Tab>
      <Tab
        to="/admin/subscribers/templates"
        icon={<FileCode2 className="h-3.5 w-3.5" aria-hidden />}
      >
        Templates
      </Tab>
      <Tab to="/admin/subscribers/broadcasts" icon={<Send className="h-3.5 w-3.5" aria-hidden />}>
        Broadcasts
      </Tab>
      <Tab to="/admin/subscribers/automations" icon={<Zap className="h-3.5 w-3.5" aria-hidden />}>
        Automations
      </Tab>
    </nav>
  );
}

interface TabProps {
  to: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  end?: boolean;
}

function Tab({ to, icon, children, end }: TabProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-semibold transition-colors',
          isActive
            ? 'bg-or-slate-900 text-white'
            : 'text-or-slate-600 hover:bg-or-slate-100 hover:text-or-slate-800',
        )
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}
